// extracted by mini-css-extract-plugin
module.exports = {"SectionBanner":"FriendsView_SectionBanner__298LM","Wrapper":"FriendsView_Wrapper__1KaBX","Action":"FriendsView_Action__1CKxC"};